const PriceTagSVG = (): JSX.Element => (
  <svg
    aria-hidden="true"
    width="139px"
    height="136px"
    viewBox="0 0 139 136"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g
        transform="translate(-777.000000, -1297.000000)"
        fillRule="nonzero"
      >
        <g transform="translate(777.000000, 1297.000000)">
          <path
            d="M106.522558,29.5491304 C109.580883,25.1680305 116.161617,14.1384797 111.214464,6.38959551 C108.829064,2.65500014 104.733508,1.38262419 102.986226,0.841577837 C97.7513396,-0.788438924 89.1031038,-0.845753156 77.6471498,8.10902247 C73.7186648,11.1787727 66.5276579,19.0720888 65.3419191,28.2469511 L58.2042819,28.2469511 C57.6125727,28.2469511 57.0417474,28.4716229 56.6101478,28.8705299 L35.726294,48.3321506 C35.2622084,48.7700313 35,49.372977 35,50.0034336 L35,133.707431 C35,134.975222 36.0372314,136 37.3204282,136 L102.292418,136 C103.575614,136 104.612846,134.975222 104.612846,133.707431 L104.612846,50.0034336 C104.612846,49.372977 104.350637,48.7700313 103.886552,48.3344431 L95.3682599,40.3952757 C99.4266888,37.6671183 103.318047,34.1411467 106.522558,29.5491304 Z M99.9719894,50.9938235 L99.9719894,131.414861 L39.6408564,131.414861 L39.6408564,50.9938235 L59.1254919,32.8343822 L80.4850335,32.8343822 L87.6644383,39.5240994 C84.4019162,41.1311904 81.1927641,42.2453791 78.3363169,42.9881716 C76.9185353,39.7166752 73.6304886,37.4195208 69.8064229,37.4195208 C64.6875583,37.4195208 60.5247101,41.5323901 60.5247101,46.5897979 C60.5247101,51.6472057 64.6875583,55.760075 69.8064229,55.760075 C74.5818641,55.760075 78.4778631,52.1699115 78.9860368,47.584773 C82.7080037,46.6677453 86.9891937,45.1706975 91.2657428,42.8804208 L99.9719894,50.9938235 Z M73.9878345,48.5430669 C73.2429771,50.0928438 71.6558042,51.1749365 69.8064229,51.1749365 C67.2469906,51.1749365 65.1655665,49.1185018 65.1655665,46.5897979 C65.1655665,44.061094 67.2469906,42.0046593 69.8064229,42.0046593 C71.3750324,42.0046593 72.7580076,42.7818403 73.600323,43.9648061 C72.0456361,44.194063 70.7345942,44.2972286 69.8064229,44.2972286 L69.8064229,48.8823672 C70.8738199,48.8823672 72.3171262,48.7746164 73.9878345,48.5430669 Z M91.8968993,37.162753 L83.002698,28.8728225 C82.5710984,28.4739154 82.0002731,28.2492436 81.4085639,28.2492436 L70.0361453,28.2492436 C71.3007787,20.4957743 77.8583087,13.7945943 80.5291216,11.7037711 C88.4417817,5.51841918 95.5283694,3.33360065 101.596289,5.2180926 C103.072081,5.67431389 105.812507,6.52714966 107.29062,8.8380595 C110.128504,13.2810588 106.780126,21.1055977 102.700813,26.9447717 C99.6424886,31.3258716 95.8439477,34.6523896 91.8968993,37.162753 Z"
            id="Shape"
            fill="#000000"
          ></path>
          <path
            d="M69.0009454,65 C57.5860436,65 48.300942,74.88784 48.300942,87.04 C48.300942,92.06744 49.9063423,96.6912 52.5766427,100.4032 L46.1182417,119.94688 C45.8422416,120.77976 46.0584417,121.7008 46.6725418,122.32024 C47.1118419,122.76104 47.700642,123 48.300942,123 C48.5424421,123 48.7908421,122.96056 49.0277422,122.87936 L55.0215431,120.8656 L58.7705438,122.75408 C59.3685439,123.05568 60.063144,123.0812 60.6795441,122.82136 C61.2959442,122.56152 61.7720442,122.0488 61.9790443,121.41312 L66.132845,108.84336 C67.0735451,108.98256 68.0257453,109.08 69.0009454,109.08 C69.9761456,109.08 70.9283457,108.98256 71.8667459,108.84336 L76.0205466,121.41312 C76.2298466,122.0488 76.7059467,122.56384 77.3200468,122.82136 C77.9364469,123.07656 78.628747,123.05336 79.2290471,122.75408 L82.9780477,120.8656 L88.9718487,122.87936 C89.2110487,122.96056 89.4594487,123 89.7009488,123 C90.3012489,123 90.890049,122.76104 91.3270491,122.32024 C91.9434492,121.69848 92.1573492,120.77976 91.8813491,119.94688 L85.4229481,100.4032 C88.0955485,96.6912 89.7009488,92.06744 89.7009488,87.04 C89.7009488,74.88784 80.4158473,65 69.0009454,65 Z M61.6846442,107.6416 L58.4577437,117.4088 L56.2290433,116.28592 C55.9070433,116.1212 55.5551432,116.04 55.2009432,116.04 C54.9571431,116.04 54.7110431,116.07944 54.4741431,116.16064 L51.9372426,117.01208 L56.1393433,104.29384 C56.1968433,104.34256 56.2612433,104.37504 56.3187434,104.42376 C57.0570435,105.03392 57.8321436,105.59304 58.6440437,106.09648 C58.7153437,106.14056 58.7843438,106.18928 58.8556438,106.23336 C59.7319439,106.76 60.6496441,107.2124 61.5995442,107.59984 C61.6294442,107.61144 61.6547442,107.63 61.6846442,107.6416 Z M65.1898448,103.92728 C65.1852448,103.92728 65.1829448,103.92264 65.1783448,103.92264 C63.6051445,103.50736 62.1239443,102.84152 60.7577441,101.95992 C60.6979441,101.92048 60.6358441,101.88104 60.576044,101.83928 C59.2489438,100.95536 58.0391436,99.86264 56.9834435,98.57968 C54.4534431,95.50336 52.9009428,91.46888 52.9009428,87.04 C52.9009428,77.44448 60.125244,69.64 69.0009454,69.64 C77.8766469,69.64 85.100948,77.44448 85.100948,87.04 C85.100948,91.46888 83.5484478,95.50336 81.0184474,98.57736 C79.9627472,99.86264 78.752947,100.95536 77.4258468,101.83928 C77.3660468,101.87872 77.3062468,101.91816 77.2441468,101.9576 C75.8802465,102.8392 74.3967463,103.50504 72.823546,103.92032 C72.818946,103.92032 72.816646,103.92496 72.812046,103.92496 C71.5884458,104.24976 70.3165456,104.44 69.0009454,104.44 C67.6853452,104.44 66.413445,104.24976 65.1898448,103.92728 Z M83.5277478,116.16064 C82.9458477,115.96112 82.3202476,116.00984 81.7705475,116.28592 L79.5418471,117.4088 L76.3149466,107.6416 C76.3448466,107.63 76.3724466,107.61144 76.4000466,107.59984 C77.3499468,107.21008 78.2676469,106.76 79.1439471,106.23104 C79.2152471,106.18696 79.2842471,106.13824 79.3555471,106.09416 C80.1674472,105.59304 80.9425474,105.03392 81.6808475,104.42144 C81.7383475,104.37504 81.8027475,104.34024 81.8602475,104.29152 L86.0623482,117.00976 L83.5277478,116.16064 Z"
            id="Shape"
            fill="#000000"
          ></path>
          <path
            d="M71.3333333,97.2014545 C74.0423333,96.2229091 76,93.6229091 76,90.5454545 C76,89.8032727 75.6546667,89.1012727 75.0666667,88.6545455 L66.893,82.4429091 C67.2663333,81.644 68.0713333,81.0909091 69,81.0909091 C70.288,81.0909091 71.3333333,82.1498182 71.3333333,83.4545455 L76,83.4545455 C76,80.3770909 74.0423333,77.7770909 71.3333333,76.7985455 L71.3333333,74 L66.6666667,74 L66.6666667,76.7985455 C63.9576667,77.7770909 62,80.3770909 62,83.4545455 C62,84.1967273 62.3453333,84.8987273 62.9333333,85.3454545 L71.107,91.5570909 C70.7336667,92.356 69.9286667,92.9090909 69,92.9090909 C67.712,92.9090909 66.6666667,91.8501818 66.6666667,90.5454545 L62,90.5454545 C62,93.6229091 63.9576667,96.2229091 66.6666667,97.2014545 L66.6666667,100 L71.3333333,100 L71.3333333,97.2014545 Z"
            id="Path"
            fill="#000000"
          ></path>
          <rect
            id="Rectangle"
            fill="#09ADB9"
            x="30"
            y="6"
            width="5"
            height="7"
          ></rect>
          <rect
            id="Rectangle"
            fill="#09ADB9"
            x="42"
            y="19"
            width="7"
            height="5"
          ></rect>
          <rect
            id="Rectangle"
            fill="#09ADB9"
            x="30"
            y="31"
            width="5"
            height="7"
          ></rect>
          <rect
            id="Rectangle"
            fill="#09ADB9"
            x="16"
            y="19"
            width="7"
            height="5"
          ></rect>
          <polygon
            id="Rectangle"
            fill="#09ADB9"
            transform="translate(41.925558, 12.509085) rotate(-45.000000) translate(-41.925558, -12.509085) "
            points="38.6802806 10.2139804 45.1708356 10.2139804 45.1708356 14.8041891 38.6802806 14.8041891"
          ></polygon>
          <polygon
            id="Rectangle"
            fill="#09ADB9"
            transform="translate(41.925558, 30.869866) rotate(-45.000000) translate(-41.925558, -30.869866) "
            points="39.6304538 27.6245886 44.2206624 27.6245886 44.2206624 34.1151437 39.6304538 34.1151437"
          ></polygon>
          <polygon
            id="Rectangle"
            fill="#09ADB9"
            transform="translate(23.564547, 30.869866) rotate(-45.000000) translate(-23.564547, -30.869866) "
            points="20.3192697 28.5747618 26.8098248 28.5747618 26.8098248 33.1649705 20.3192697 33.1649705"
          ></polygon>
          <polygon
            id="Rectangle"
            fill="#09ADB9"
            transform="translate(23.564777, 12.508855) rotate(-45.000000) translate(-23.564777, -12.508855) "
            points="21.2696724 9.2635777 25.8598811 9.2635777 25.8598811 15.7541328 21.2696724 15.7541328"
          ></polygon>
          <path
            d="M24,58 C20.1406667,58 17,61.1406667 17,65 C17,68.8593333 20.1406667,72 24,72 C27.8593333,72 31,68.8593333 31,65 C31,61.1406667 27.8593333,58 24,58 Z M24,67.3333333 C22.712,67.3333333 21.6666667,66.288 21.6666667,65 C21.6666667,63.712 22.712,62.6666667 24,62.6666667 C25.288,62.6666667 26.3333333,63.712 26.3333333,65 C26.3333333,66.288 25.288,67.3333333 24,67.3333333 Z"
            id="Shape"
            fill="#000000"
          ></path>
          <rect
            id="Rectangle"
            fill="#000000"
            x="0"
            y="88"
            width="5"
            height="5"
          ></rect>
          <rect
            id="Rectangle"
            fill="#000000"
            x="5"
            y="84"
            width="5"
            height="5"
          ></rect>
          <rect
            id="Rectangle"
            fill="#000000"
            x="9"
            y="88"
            width="5"
            height="5"
          ></rect>
          <rect
            id="Rectangle"
            fill="#000000"
            x="5"
            y="93"
            width="5"
            height="5"
          ></rect>
          <path
            d="M19,108 C15.1406667,108 12,111.140667 12,115 C12,118.859333 15.1406667,122 19,122 C22.8593333,122 26,118.859333 26,115 C26,111.140667 22.8593333,108 19,108 Z M19,117.333333 C17.712,117.333333 16.6666667,116.288 16.6666667,115 C16.6666667,113.712 17.712,112.666667 19,112.666667 C20.288,112.666667 21.3333333,113.712 21.3333333,115 C21.3333333,116.288 20.288,117.333333 19,117.333333 Z"
            id="Shape"
            fill="#000000"
          ></path>
          <path
            d="M118,108 C114.140667,108 111,111.140667 111,115 C111,118.859333 114.140667,122 118,122 C121.859333,122 125,118.859333 125,115 C125,111.140667 121.859333,108 118,108 Z M118,117.333333 C116.712,117.333333 115.666667,116.288 115.666667,115 C115.666667,113.712 116.712,112.666667 118,112.666667 C119.288,112.666667 120.333333,113.712 120.333333,115 C120.333333,116.288 119.288,117.333333 118,117.333333 Z"
            id="Shape"
            fill="#000000"
          ></path>
          <rect
            id="Rectangle"
            fill="#09ADB9"
            x="125"
            y="90"
            width="5"
            height="5"
          ></rect>
          <rect
            id="Rectangle"
            fill="#09ADB9"
            x="129"
            y="86"
            width="5"
            height="5"
          ></rect>
          <rect
            id="Rectangle"
            fill="#09ADB9"
            x="134"
            y="90"
            width="5"
            height="5"
          ></rect>
          <rect
            id="Rectangle"
            fill="#09ADB9"
            x="129"
            y="95"
            width="5"
            height="5"
          ></rect>
          <path
            d="M122,65 C122,61.1406667 118.859333,58 115,58 C111.140667,58 108,61.1406667 108,65 C108,68.8593333 111.140667,72 115,72 C118.859333,72 122,68.8593333 122,65 Z M112.666667,65 C112.666667,63.712 113.712,62.6666667 115,62.6666667 C116.288,62.6666667 117.333333,63.712 117.333333,65 C117.333333,66.288 116.288,67.3333333 115,67.3333333 C113.712,67.3333333 112.666667,66.288 112.666667,65 Z"
            id="Shape"
            fill="#000000"
          ></path>
          <rect
            id="Rectangle"
            fill="#000000"
            x="125"
            y="35"
            width="5"
            height="5"
          ></rect>
          <rect
            id="Rectangle"
            fill="#000000"
            x="129"
            y="31"
            width="5"
            height="5"
          ></rect>
          <rect
            id="Rectangle"
            fill="#000000"
            x="134"
            y="35"
            width="5"
            height="5"
          ></rect>
          <rect
            id="Rectangle"
            fill="#000000"
            x="129"
            y="40"
            width="5"
            height="5"
          ></rect>
        </g>
      </g>
    </g>
  </svg>
);

export default PriceTagSVG;
